export default __webpack_public_path__ + "static/media/cd_logo.b3effb6b.jpg";